module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Australia: A Miracle of Life")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction: Australia")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#australia"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#part-one-australia-the-natural-world-and-our-interactions-with-it"
    }
  }, [_vm._v("Part One: Australia: The Natural World (And Our Interactions with it)")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#the-beach"
    }
  }, [_vm._v("The Beach")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#snorkelling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snorkelling")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#whale-watching",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whale Watching")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-rivers-journey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A River’s Journey")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#rafting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rafting")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#waves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waves")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#australian-animals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australian Animals")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#part-two-my-home-land-of-tasmania-and-other-special-places",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: My Home Land of Tasmania and Other Special Places")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hobart-summer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hobart Summer")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#mount-wellington",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mount Wellington")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#tasmania",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tasmania")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#climbing-hartz-peak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climbing Hartz Peak")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#garden-island-creek-originally-written-as-a-song",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garden Island Creek (Originally Written as a Song)")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#lamington-national-park",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamington National Park")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#great-barrier-reef",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Great Barrier Reef")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#norfolk-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norfolk Island")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#part-three-australian-culture-an-observation-on-elements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Australian Culture, an Observation on Elements")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#toxic-masculinity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toxic Masculinity")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#womanewscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Womanewscript")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#my-dog-elly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Dog Elly")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#camping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camping")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#coffee-culture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coffee Culture")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("School")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#the-pool",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pool")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#parks-and-gardens",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parks and Gardens")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#cities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cities")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#sport",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sport")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#drinking-culture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinking Culture")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#australian-food",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australian Food")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#australia-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australia Day")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0